export function generatePickupSlots() {
  const slots = [];
  const now = new Date();

  const days = [
    new Date(), // today
    new Date(Date.now() + 86400000) // tomorrow
  ];

  days.forEach(day => {
    let start = new Date(day);
    start.setHours(18, 30, 0, 0); // 6:30 PM

    let end = new Date(day);
    end.setHours(23, 0, 0, 0); // 11:00 PM

    while (start < end) {
      let next = new Date(start.getTime() + 15 * 60000); // 15 min slots

      if (start > now) {
        // Format: Tuesday, March 10 - 6:45 PM - 7:00 PM
        const options = { weekday: 'long', month: 'long', day: 'numeric' };
        const dateStr = start.toLocaleDateString(undefined, options);

        const startTime = start.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        const endTime = next.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

        slots.push(`${dateStr} - ${startTime} - ${endTime}`);
      }

      start = next;
    }
  });

  return slots;
}